module.exports = __webpack_public_path__ + "img/AGR-A-3-II.8f24ff8e.png";